/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { CustomCarouselContainer } from './style';
import Icon from '../../atoms/Icon';

const SlickButtonFix = ({ currentSlide, slideCount, children, ...props }) => (
  <span {...props}>{children}</span>
);

SlickButtonFix.propTypes = {
  children: PropTypes.node,
  currentSlide: PropTypes.number,
  slideCount: PropTypes.number,
};

const CustomCarousel = ({ children, config, onSlideChange }) => {
  const slider = useRef();
  const dotsRef = useRef(null);
  const [dotsWidth, setDotsWidth] = useState(0);

  const customDots = (dots) => <ul ref={dotsRef}>{dots}</ul>;

  useEffect(() => {
    if (slider.current) {
      const currentBreakpoint = config.responsive.filter(
        (item) => item.breakpoint === slider.current.state.breakpoint
      );
      if (currentBreakpoint.length) {
        slider.current.slickGoTo(
          children.length - currentBreakpoint[0].settings.goToSlide
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    function updateSize() {
      if (dotsRef?.current?.offsetWidth) {
        setDotsWidth(dotsRef.current.offsetWidth);
      }
    }
    window.addEventListener('resize', updateSize);
    setTimeout(() => {
      updateSize();
    }, 100);

    return () => window.removeEventListener('resize', updateSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dotsRef?.current]);

  return (
    <CustomCarouselContainer dotsWidth={dotsWidth}>
      <Slider
        ref={slider}
        {...config}
        dir="ltr"
        afterChange={onSlideChange}
        prevArrow={
          <SlickButtonFix>
            <Icon type="chevron-left" size={25} />
          </SlickButtonFix>
        }
        nextArrow={
          <SlickButtonFix>
            <Icon type="chevron-right" size={25} />
          </SlickButtonFix>
        }
        appendDots={customDots}
      >
        {children}
      </Slider>
    </CustomCarouselContainer>
  );
};

CustomCarousel.propTypes = {
  children: PropTypes.node,
  config: PropTypes.shape({ responsive: PropTypes.array }),
  responsive: PropTypes.array,
  onSlideChange: PropTypes.func,
};

export default CustomCarousel;
